module.exports = __webpack_public_path__ + "static/media/GettingPaid13.5ab29895.png";